import { useContext } from 'react';
import BuilderContext, { IBuilderContext } from '../../context';
import { reportAndThrow } from '~/util/reportAndThrow';

const useBuilderContext = (): IBuilderContext => {
  const context = useContext(BuilderContext);

  if (context === null) {
    return reportAndThrow(
      `Builder context should be set before using useBuilderContext but it wasn't`,
    );
  }

  return context;
};

export default useBuilderContext;
